export default __webpack_public_path__ + "static/media/369.c38a7112.jpg";